import React from 'react'

// components
import ActionButton from 'components/FileActionButtons/ActionButton'
import { IconStar } from 'components/shared/icons'

const withStudioShowcaseSubmitButtonAction = (WrappedComponent) => {
  const StudioShowcaseSubmitButtonAction = (props) => {
    const {
      file,
      activeAction,
      setActiveAction
    } = props

    const handleClick = (e) => {
      e.preventDefault()
      setActiveAction('submit')
    }

    const active = activeAction === 'submit'
    const disabled = file.submitted || !!(activeAction && !active)

    return (
      <WrappedComponent
        {...props}
        showcase
        active={active}
        disabled={disabled}
        icon={IconStar}
        onClick={handleClick}
        label='Showcase'
      />
    )
  }

  return StudioShowcaseSubmitButtonAction
}

export default withStudioShowcaseSubmitButtonAction(ActionButton)
